import React from "react"

export type NoteActionsProps = {
  children: React.ReactNode
}

export function NoteActions({ children }: NoteActionsProps) {
  return (
    <div
      className="[grid-area:actions] flex flex-wrap items-center gap-2"
      data-slot="note-actions"
    >
      {children}
    </div>
  )
}
